/**
 * @name ApiHandler
 * @desc this is an abstraction of ApiHandler services
 */
class ApiHandler {

}

export default ApiHandler;